import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import {UnitSelectionCandidate} from '../../model/unit-selection-candidate';
import {UnitConversionUtils} from '../../configurator/unit-conversion-utils';
import {PercentPipe} from '@angular/common';
import {CandidateRatingOutputComponent} from '../candidate-rating-output/candidate-rating-output.component';
import {CandidateRatingInputComponent} from '../candidate-rating-input/candidate-rating-input.component';

@Component({
    selector: 'app-selection-candidate-detail',
    templateUrl: './selection-candidate-detail.component.html',
    styleUrls: ['./selection-candidate-detail.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CandidateRatingInputComponent, CandidateRatingOutputComponent, PercentPipe]
})
export class SelectionCandidateDetailComponent {

  readonly candidate = input.required<UnitSelectionCandidate>();
  readonly metricInput = input.required<boolean>();
  readonly isSureflow = input.required<boolean>();

  getDimensionValue(input: number): string {
    if (!input || isNaN(input)) {
      return '';
    }
    return this.metricInput() ? UnitConversionUtils.convertDimensionalValue(input, this.metricInput()) : input.toString();
  }

  getDimensionUnits(): string {
    return UnitConversionUtils.getDimensionalUnits(this.metricInput());
  }

  getAirflowValue(input: number): string {
    if (!input || isNaN(input)) {
      return '';
    }
    return this.metricInput() ? UnitConversionUtils.convertAirflow(input, this.metricInput()) : input.toString();
  }

  getAirflowUnits(): string {
    return UnitConversionUtils.getAirflowUnits(this.metricInput());
  }

  getWeightValue(input: number): string {
    if (!input || isNaN(input)) {
      return '';
    }
    return this.metricInput() ? UnitConversionUtils.convertWeightValue(input, this.metricInput()) : input.toString();
  }

  getWeightUnits(): string {
    return UnitConversionUtils.getWeightUnits(this.metricInput());
  }

}
